module.exports = __webpack_public_path__ + "static/media/img_chat_header.03931ca0.png";